module.exports = __webpack_public_path__ + "static/media/layer-minus.4e8af329.svg";